import { MyLink } from '@ui-kit/Link';
import IconMap from './map-point.svg';
import classNames from 'classnames';

import styles from './FooterDown.module.scss';

export const FooterDown = ({ shortFooter }: { shortFooter?: boolean }): JSX.Element => {
  const data = new Date();
  return (
    <div className={classNames(styles.Container, shortFooter && styles.Short)} itemScope itemType="https://schema.org/WPFooter">
      <MyLink className={styles.Info} href={'/contacts/'}>
        <IconMap /> Контактная информация
      </MyLink>
      <div className={styles.Text}>
        1998-<span itemProp="copyrightYear">{data.getFullYear()}</span> © Сеть шинных и сервисных центров{' '}
        <span itemProp="copyrightHolder">Колесо.ру</span>
      </div>
    </div>
  );
};
